module.exports = __webpack_public_path__ + "static/media/D09.d511cbe1.svg";